<h2 mat-dialog-title class="replace-dialog-title">
  <mat-icon>swap_horiz</mat-icon>
  Перенести місто
</h2>

<mat-dialog-content class="replace-dialog-content">
  <p class="replace-dialog-info">
    Всі кандидати (зокрема видалені) та проекти, прив'язані до міста
    <strong>{{ sourceCity }}</strong>, будуть перенесені до обраного міста.
  </p>

  <mat-form-field appearance="outline" class="search-field">
    <mat-label>Пошук міста</mat-label>
    <mat-icon matPrefix>search</mat-icon>
    <input matInput [formControl]="searchControl" placeholder="Введіть назву..." />
  </mat-form-field>

  <mat-form-field appearance="outline" class="target-field">
    <mat-label>Перенести до міста</mat-label>
    <mat-select [formControl]="targetControl">
      @let cities = filteredCities$ | async; @if (isLoading()) {
      <mat-option disabled>Завантаження міст...</mat-option>
      } @else { @for (city of cities; track city.id) {
      <mat-option [value]="city.id">{{ cityLabel(city) }}</mat-option>
      } @empty {
      <mat-option disabled>Міст не знайдено</mat-option>
      } }
    </mat-select>
    @if (targetControl.invalid && targetControl.touched) {
    <mat-error>Оберіть місто для переносу</mat-error>
    }
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="onCancel()">Скасувати</button>
  <button
    mat-raised-button
    color="warn"
    type="button"
    (click)="onConfirm()"
    [disabled]="targetControl.invalid || isLoading()"
  >
    Перенести
  </button>
</mat-dialog-actions>
